import React, { useState } from "react";
import { toast } from "../../../utils/appToast";

import { setRfpAutoRenew } from "../../../services/rfpBillingApi";
import Dialog from "./Dialog";

// Only shown when switching auto-pay OFF — turning it on needs no
// confirmation (per the handoff) since it only sets up a mandate; nothing
// is charged until the period actually ends.
export default function AutoPayOffDialog({ open, onClose, onChanged }) {
  const [saving, setSaving] = useState(false);

  const handleConfirm = async () => {
    setSaving(true);
    try {
      await setRfpAutoRenew({ enabled: false });
      toast.success("Auto-pay turned off.");
      onChanged?.();
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.error || "Couldn't turn off auto-pay — try again");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} title="Turn off auto-pay?" maxWidth={420}>
      <h2 className="text-[18px] font-semibold text-[#1A1A1A]">Turn off auto-pay?</h2>
      <p className="mt-2 text-[13.5px] text-[#52525B]">
        Your plan won't renew automatically. You'll get a reminder before the current period ends, and
        you'll need to renew manually to keep access.
      </p>
      <div className="mt-6 flex justify-end gap-3">
        <button
          type="button"
          onClick={onClose}
          className="rounded-[9px] bg-[#A04A97] px-4 py-2 text-[14px] font-semibold text-white"
        >
          Keep auto-pay on
        </button>
        <button
          type="button"
          onClick={handleConfirm}
          disabled={saving}
          className="rounded-[9px] px-4 py-2 text-[14px] font-medium text-[#52525B] disabled:opacity-50"
        >
          {saving ? "Turning off…" : "Turn off"}
        </button>
      </div>
    </Dialog>
  );
}
